export const PRODUCT_SLUGS = {
  FOOD_SENSITIVITY_PKI: 'food-sensitivity',
  FOOD_SENSITIVITY_COMPREHENSIVE: 'food-sensitivity-comprehensive-test',
  HEART_HEALTH: 'heart-health-test',
  METABOLISM: 'metabolism',
  STD_5_PANEL: 'at-home-std-test',
  WOMENS_HEALTH: 'womens-health-test',
  THYROID: 'thyroid-test',
  STD_IN_PERSON_TEST_EXPANDED: 'std-in-person-test-expanded',
  STD_IN_PERSON_TEST_BASIC: 'std-in-person-test-basic',
  CHLAMYDIA_GONORRHEA_IN_PERSON_TEST: 'chlamydia-gonorrhea-in-person-test',
  HIV_IN_PERSON_TEST: 'hiv-in-person-test',
  EVERLYWELL_360_FEMALE: '360-full-body-test-female-membership',
  EVERLYWELL_360_MALE: '360-full-body-test-male-membership',
  GALLERI_CANCER_SCREENING_TEST: 'galleri-cancer-screening-test',
  CARIS_DETECT: 'caris-detect-mced-test',
};

export const VARIANT_SKUS = {
  GALLERI_ADD_ON: 'quest-galleri-add-on',
};

export const PHONE_NUMBER_NEEDED_SKUS = [];

export const VITAMINS = [
  'multivitamin-gummy',
  'vitamin-b12-500-mcg',
  'vitamin-b6-50-mg',
  'vitamin-d3-2000-iu',
  'omega-3-fish-oil-1000-mg',
];

export const ELIMINATION_DIET_COACHING_SLUG = 'elimination-diet-coaching';

export const NO_INDEX_SLUGS = ['members/consentandnotice'];

export const QUEST_SLUGS = [
  PRODUCT_SLUGS.STD_IN_PERSON_TEST_EXPANDED,
  PRODUCT_SLUGS.STD_IN_PERSON_TEST_BASIC,
  PRODUCT_SLUGS.CHLAMYDIA_GONORRHEA_IN_PERSON_TEST,
  PRODUCT_SLUGS.HIV_IN_PERSON_TEST,
  PRODUCT_SLUGS.EVERLYWELL_360_FEMALE,
  PRODUCT_SLUGS.EVERLYWELL_360_MALE,
  PRODUCT_SLUGS.GALLERI_CANCER_SCREENING_TEST,
];

/**
 * Everlywell 360 isn't a regular Spree product surfaced via the Eva product
 * graph (it's a quiz-funneled bundle), so promo lookups for it have to use
 * the canonical productId/basePrice instead of a slug. These match the
 * values already used by the Everlywell 360 marketing hero
 * (see HeroV3.tsx) and Spree's Female membership product.
 */
export const CARIS_MDP_SLUG = '0de9fbed-5fc2-45d8-b4cb-c1e2ea273f2b';

export const EVERLYWELL_360 = {
  PRODUCT_ID: 353,
  BASE_PRICE: 399,
} as const;
